var _rect, _g, _g2, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Address_Book_icon",
    "data-name": "Address Book icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 40,
    height: 40,
    rx: 13,
    fill: "none",
    opacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_16",
    "data-name": "Subtraction 16",
    transform: "translate(5.625 20)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.677,12.5H.073A10.822,10.822,0,0,1,0,11.25C0,5.047,5.327,0,11.874,0S23.75,5.047,23.75,11.25a10.83,10.83,0,0,1-.072,1.249Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.71772003173828 10.4998779296875 C 21.30880355834961 5.748809814453125 17.05020523071289 1.999997496604919 11.8743782043457 1.999997496604919 C 6.699140548706055 1.999997496604919 2.441022634506226 5.748809814453125 2.032152652740479 10.4998779296875 L 21.71772003173828 10.4998779296875 M 23.67734718322754 12.4998779296875 L 0.07251801341772079 12.4998779296875 C 0.02397801168262959 12.08382797241211 -1.988830490518012e-06 11.66367721557617 -1.988830490518012e-06 11.24999713897705 C -1.988830490518012e-06 5.046727657318115 5.326828002929688 -2.465667648721137e-06 11.8743782043457 -2.465667648721137e-06 C 18.42254829406738 -2.465667648721137e-06 23.7498779296875 5.046727657318115 23.7498779296875 11.24999713897705 C 23.7498779296875 11.66641712188721 23.72550773620605 12.0865478515625 23.6774787902832 12.49877738952637 L 23.67734718322754 12.4998779296875 Z",
    stroke: "none",
    fill: "#ebecff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(10.625 7.5)",
    fill: "none",
    stroke: "#ebecff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    fill: "none"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 5,
    transform: "translate(29.375 15.625)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x2: 7.5,
    transform: "translate(26.875 19.375)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x2: 3.75,
    transform: "translate(30.625 23.125)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address-book.e4b981ed.svg";
export { ForwardRef as ReactComponent };